import type { SiteConfig } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ImageField, SelectField } from './fields.tsx';

export function VideoConfigSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const v = config.video;
  const set = (patch: Partial<SiteConfig['video']>) => update({ video: { ...v, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Vidéo</h2>
      <TextField label="Titre" value={v.title} onChange={(v2) => set({ title: v2 })} />
      <TextAreaField label="Sous-titre" value={v.subtitle} onChange={(v2) => set({ subtitle: v2 })} rows={2} />
      <TextField label="URL de la vidéo" value={v.url} onChange={(v2) => set({ url: v2 })} />
      <SelectField
        label="Type"
        value={v.type}
        onChange={(v2) => set({ type: v2 })}
        options={[
          { value: 'youtube', label: 'YouTube' },
          { value: 'vimeo', label: 'Vimeo' },
          { value: 'mp4', label: 'Fichier MP4' },
        ]}
      />
      <ImageField label="Image miniature" value={v.thumbnail} onChange={(v2) => set({ thumbnail: v2 })} />
      <TextField label="Texte du bouton" value={v.buttonText} onChange={(v2) => set({ buttonText: v2 })} />
    </div>
  );
}
